
import React from "react";
import { Helmet } from "react-helmet";

const SITE_URL = "https://restaurantwala.in";

const PageTitle = ({
  title,
  description,
  url = "",
  keywords = "",
  image = `${SITE_URL}/logo192.png`,
}) => {
  // Normalize the page path
  const path = url
    ? `/${url.replace(/^\/+|\/+$/g, "")}`
    : "";

  const pageUrl = `${SITE_URL}${path || "/"}`;

  // Organization schema: use the main website URL
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "RestaurantWala",
    url: `${SITE_URL}/`,
    logo: `${SITE_URL}/logo192.png`,
    description:
      "RestaurantWala helps restaurants manage digital menus, QR ordering, billing and direct orders.",
    telephone: "+91-6378788756",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Shiv Manglam 6, AB 23, Kalwar Road, Govindpura, Jhotwara",
      addressLocality: "Jaipur",
      addressRegion: "Rajasthan",
      postalCode: "302013",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.instagram.com/restaurantwala.in/",
    ],
  };

  return (
    <Helmet>
      <title>{title || "RestaurantWala"}</title>

      {description && (
        <meta name="description" content={description} />
      )}

      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title || "RestaurantWala"} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="RestaurantWala" />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || "RestaurantWala"} />
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta name="twitter:image" content={image} />

      {/* Organization schema */}
      {path === "" && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default PageTitle;


// import React from 'react';
// import { Helmet } from 'react-helmet';

// const PageTitle = ({ title, description, url, keywords }) => {
//   // Structured data for SEO
//   const structuredData = {
//     "@context": "https://schema.org",
//     "@type": "Organization",
//     "name": "RestaurantWala",
//     "url": `https://restaurantwala.in/${url}`,
//     "author": {
//       "@type": "Organization",
//       "name": "RestaurantWala"
//     },
//     "logo": "https://restaurantwala.in/logo192.png",  
//     "description": description,
//     "publisher": {
//       "@type": "Organization",
//       "name": "RestaurantWala",
//       "logo": {
//         "@type": "ImageObject",
//         "url": "https://restaurantwala.in/logo192.png"
//       }
//     },
//     "address": {
//       "@type": "PostalAddress",
//       "streetAddress": "Shiv Manglam 6, AB 23, Kalwar Rd,Govindpura, Jhotwara, Hathod",
//       "addressLocality": "Jaipur",
//       "addressRegion": "Rajasthan",
//       "postalCode": "302013",
//       "addressCountry": "India"
//     },
//     "telephone": "+91-6378788756",  
//     "sameAs": [ 
//       "https://www.instagram.com/restaurantwala.in?utm_source=qr&stkn=MjB1bjAyYXRoNXpu"
//     ]
//   };

//   return (
//     <Helmet>
//       <title>{title}</title>

//       <meta name="description" content={description} />
//       <meta name="keywords" content={keywords} /> 
//       <link rel="canonical" href={`https://restaurantwala.in/${url}`} />

//       {/* Open Graph Meta Tags for Social Sharing */}
//       <meta property="og:title" content={title} />
//       <meta property="og:description" content={description} />
//       <meta property="og:url" content={`https://restaurantwala.in/${url}`} />
//       <meta property="og:type" content="website" />
//       <meta property="og:image" content="https://restaurantwala.in/logo192.png" /> 
//       <meta property="og:site_name" content="Restaurantwala" />

//       {/* Twitter Card */}
//       <meta name="twitter:card" content="summary_large_image" />
//       <meta name="twitter:title" content={title} />
//       <meta name="twitter:description" content={description} />
      
//       {/* Schema.org structured data */}
//       <script type="application/ld+json">
//         {JSON.stringify(structuredData)}
//       </script>
//     </Helmet>
//   );
// };

// export default PageTitle;
